var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3194,
    height: 613,
    viewBox: "0 0 3194 613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-4662 -1156)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 3156,
    height: 578,
    transform: "translate(4700 1191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 2822,
    height: 587,
    transform: "translate(4662 1156)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1080",
    "data-name": "Rectangle 1080",
    width: 1546,
    height: 512,
    transform: "translate(4784 1201)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Inventory",
    transform: "translate(5325 1602)",
    fill: "#363b64",
    fontSize: 392,
    fontFamily: "RobotoCondensed-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Task Manager")), /*#__PURE__*/React.createElement("g", {
    id: "list-6246",
    transform: "translate(5016.96 1432.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2377",
    "data-name": "Group 2377",
    transform: "translate(-126.036 -126.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M265.105,314.152H49.046A49.1,49.1,0,0,1,0,265.105V49.046A49.1,49.1,0,0,1,49.046,0H265.105a49.1,49.1,0,0,1,49.046,49.046V265.105A49.1,49.1,0,0,1,265.105,314.152ZM49.046,27.925A21.143,21.143,0,0,0,27.925,49.046V265.105a21.146,21.146,0,0,0,21.121,21.121H265.105a21.148,21.148,0,0,0,21.121-21.121V49.046a21.146,21.146,0,0,0-21.121-21.121Z",
    fill: "#cb0c9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M231.164,87.951H60.206a13.963,13.963,0,1,1,0-27.925H231.164a13.962,13.962,0,0,1,0,27.925Z",
    transform: "translate(11.389 14.783)",
    fill: "#cb0c9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M231.164,142.757H60.206a13.962,13.962,0,1,1,0-27.925H231.164a13.963,13.963,0,0,1,0,27.925Z",
    transform: "translate(11.389 28.281)",
    fill: "#cb0c9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M231.164,197.563H60.206a13.962,13.962,0,1,1,0-27.925H231.164a13.963,13.963,0,0,1,0,27.925Z",
    transform: "translate(11.389 41.778)",
    fill: "#cb0c9f"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.56930a0057d0711c59ad86e14235f78e.svg";
export { ForwardRef as ReactComponent };